import React from "react";
import Footer from "./Footer";
import HomePage from "../pages/HomePage";

const RenderLanding: React.FC = () => {
  return (
    <React.Fragment>
      <HomePage />
      <Footer />
    </React.Fragment>
  );
};

export default RenderLanding;
